import React from 'react';

import { useIntl } from 'react-intl';

import { FilterProductIcon } from '../../../../../common/ui/filters/filter-product-icon';
import type { FilterProps } from '../../../../../common/ui/filters/product-filters/types';
import SelectFilter from '../../../../../common/ui/filters/select-filter';
import { useSelectFilter } from '../../../../../controllers/filters/base-select-filter';
import { usePrimaryProduct } from '../../../../../controllers/store/bootstrap';
import { filter as pageStatusFilter } from '../../../../../controllers/store/search/filters/page-status';

import { i18n } from './messages';

const PageStatusFilter = ({
	isFilterInDropdown,
	showPrimaryProductIcon,
	fit = 'default',
	onFilterChange,
	hideOnHoverOut,
}: FilterProps): React.JSX.Element | null => {
	const [primaryProduct] = usePrimaryProduct();
	const { formatMessage } = useIntl();
	const [filterData, { loadInitialOptions, setOption }] = useSelectFilter({
		filterId: pageStatusFilter.id,
	});

	if (!filterData) {
		return null;
	}

	const { isLoading, selectedOptions, options } = filterData;

	const label =
		fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage(i18n.pageStatus);

	return (
		<SelectFilter
			contentFit={fit}
			onDropdownOpen={loadInitialOptions}
			onSelectChange={(option, ...restArgs) => {
				setOption(option, ...restArgs);
				onFilterChange?.(option);
			}}
			options={options}
			selectedOptions={selectedOptions}
			label={label}
			filterOrControlId={'pageStatus'}
			isLoading={isLoading}
			isFilterInDropdown={isFilterInDropdown}
			iconBefore={
				<FilterProductIcon
					showPrimaryProductIcon={showPrimaryProductIcon}
					primaryProduct={primaryProduct}
				/>
			}
			hideOnHoverOut={hideOnHoverOut}
		/>
	);
};

export default PageStatusFilter;
